/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Filter } from "@Internal/Contracts";
import { SelectionFilter, TextFilter } from "@Internal/Models";

/* The Facturation list is filtered server-side against the invoice mirror. Two filters are offered:
   a customer-name substring and the payment status (a multi-choice whose option ids are the raw
   mirror statuses, serialized as a comma-separated set). */
let defaultFilters: Filter[] = [];

function Get(): Filter[] {
    if( defaultFilters.length === 0 )
        defaultFilters = [
            new TextFilter(
                "Name",
                $t( "PAYMENTS_filterName" ),
                $t( "PAYMENTS_filterNamePlaceholder" )
            ),

            SelectionFilter.Multi(
                "Status",
                $t( "PAYMENTS_filterStatus" ),
                [
                    { Id: "Paid", Name: $t( "PAYMENTS_statusPaid" ) },
                    { Id: "Open", Name: $t( "PAYMENTS_statusOpen" ) },
                    { Id: "Uncollectible", Name: $t( "PAYMENTS_statusUncollectible" ) },
                    { Id: "Void", Name: $t( "PAYMENTS_statusVoid" ) },
                    { Id: "Rejected", Name: $t( "PAYMENTS_statusRejected" ) }
                ],
                $t( "PAYMENTS_filterStatusPlaceholder" )
            )
        ];

    return defaultFilters;
}

export default {
    Get
};
